export const accordionStyles = {
  control: {
    '&[data-active]': {
      backgroundColor: '#fff',
    },
    '&:hover': {
      backgroundColor: '#fff',
    },
  },
  item: {
    fontSize: '1.4rem',
    lineHeight: '2rem',
    color: '#333333',
    borderTop: `1px solid #E1E2E5`,
    borderBottom: `none`,
  },
  label: {
    color: '#333333',
    fontSize: '1.6rem',
    lineHeight: '1.3rem',
  },
  chevron: {
    '&[data-rotate]': {
      transform: 'rotate(45deg)',
      color: '#00008D',
    },
  },
};
